module.exports = __webpack_public_path__ + "media/images/al-izza-7133f36676459976053ca13f0106e17f.png";